import { createEnv } from '@t3-oss/env-core';
import z from 'zod';

export const env = createEnv({
  /*
   * Specify what prefix the client-side variables must have.
   * This is enforced both on type-level and at runtime.
   */
  clientPrefix: 'VITE_',
  client: {
    VITE_MSAL_CLIENT_ID: z.string().uuid(),
    VITE_API_URL: z.string().url(),
    VITE_PORT_MANAGEMENT_API_URL: z.string().url(),
    VITE_TENANT_MANAGEMENT_API_URL: z.string().url(),
    VITE_MAPBOX_TOKEN: z.string().nonempty(),
    VITE_MSAL_AUTHORITY: z.string().url(),
    VITE_MSAL_KNOWN_AUTH: z.string().nonempty(),
    VITE_MSAL_SCOPE: z.string().url(),
    VITE_B2B_API_BASE_URL: z.string().url().optional(),
    VITE_B2B_TOKEN_ENDPOINT: z.string().url().optional(),
    VITE_B2B_API_SCOPE: z.string().nonempty().optional(),
    VITE_APPLICATIONINSIGHTS_CONNECTION_STRING: z.string().nonempty().optional(),
  },
  shared: {
    DEV: z.boolean(),
  },
  /**
   * What object holds the environment variables at runtime.
   * Often `process.env` or `import.meta.env`
   */
  runtimeEnv: import.meta.env,
});
